module.exports = __webpack_public_path__ + "static/media/feature2videointerviewing.4985481c.png";